import { Component } from "react";

export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(err) {
        console.error("UI error caught:", err);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="flex min-h-screen items-center justify-center bg-bone px-6 text-center">
                    <div>
                        <p className="font-mono text-xs uppercase tracking-[0.2em] text-oak">
                            Steevens Complete Interiors
                        </p>
                        <h1 className="mt-4 font-serif text-4xl text-espresso">
                            Something went wrong.
                        </h1>
                        <button
                            data-testid="error-reload-button"
                            onClick={() => window.location.reload()}
                            className="mt-8 bg-espresso px-8 py-3 font-mono text-xs uppercase tracking-[0.2em] text-bone transition-colors hover:bg-oak"
                        >
                            Reload
                        </button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}
